export class PrimaryFunction {
  primaryFunctionId: number;
  name: string;
}
